module.exports = __webpack_public_path__ + "static/media/entranceP.ad15f098.jpg";